import api from "./api";

export type TipoMovimentacaoComissao = 1 | 2 | 3; // 1=Pagamento, 2=Lancamento, 3=Locacao
export type TipoCalculoComissao = 1 | 2;        // 1=Percentual, 2=Fixo
export type TipoPeriodicidadePagamento = 0 | 1 | 2 | 3 | 4; // 0=Nenhum, 1=Semanal, 2=Quinzenal, 3=Mensal, 4=Diario

/**
 * Marco que faz a comissão de uma LOCAÇÃO ser ganha. Espelha MomentoApuracaoComissao no backend.
 * 1=Início da locação, 2=Cadastro da locação, 3=Primeiro pagamento, 4=Encerramento.
 */
export type MomentoApuracaoComissao = 1 | 2 | 3 | 4;

export interface UsuarioComissaoRegraDto {
    id: string;
    idUsuario: string;
    tipoMovimentacao: TipoMovimentacaoComissao;
    idCategoria?: string | null;
    tipoCalculo: TipoCalculoComissao;
    valor: number;
    teto?: number | null;
    idEmpresa: string;
    periodicidade?: TipoPeriodicidadePagamento | null;
    nomeCategoria?: string | null;
    /** Regra de Locação: veículo a que se aplica. null = todos os veículos. */
    idVeiculo?: string | null;
    /** Regra de Locação: marco que conta como comissão ganha. */
    momentoApuracao?: MomentoApuracaoComissao | null;
    /** Só exibição. */
    placaVeiculo?: string | null;
}

export const obterRegrasPorUsuario = (idUsuario: string) =>
    api.get<UsuarioComissaoRegraDto[]>(`/Comissao/PorUsuario/${idUsuario}`);

export const salvarLoteRegras = (idUsuario: string, regras: UsuarioComissaoRegraDto[]) =>
    api.post(`/Comissao/SalvarLote/${idUsuario}`, regras);

export const obterRelatorio = (params: {
    dataInicio: string;
    dataFim: string;
    idUsuario?: string;
    tipoMovimentacao?: TipoMovimentacaoComissao;
    idCategoria?: string;
}) => api.get(`/Comissao/Relatorio`, { params });
